// extracted by mini-css-extract-plugin
export default {"button":"MarkAllReadButton_button__Twmoz"};